<template>
  <div class="prescription-upload-success">
    <div class="prescription-upload-success__body">
      <div class="title" v-if="renderedTitle.length">
        <span v-for="(node, index) in renderedTitle" :key="index" class="title-node">
          <span class="title-action" v-if="node.isAction" @click="onViewPrescription">
            {{ node.text }}
          </span>
          <span v-else>{{ node.text }}</span>
        </span>
      </div>

      <div class="service-list">
        <div v-for="(item, index) in serviceItems" :key="index" class="service-item">
          <div class="check-icon"><img class="safeIcon" :src="safeIcon" alt="" /></div>
          <div class="service-text">{{ item }}</div>
        </div>
      </div>

      <div v-if="msg.traceDescription" class="trace-source-desc">
        {{ traceDescription }}
      </div>
    </div>
    <!-- 门诊病历详情 -->
    <RecordDetail v-model:visible="visible" recordType="offLineRecord" :id="recordId" />
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue'
import safeIcon from '@/assets/img/safe.svg'
import RecordDetail from '@/components/TheDetail'

const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  }
})

// 门诊病历详情弹窗是否可见
const visible = ref(false)
// 门诊病历ID详情数据
const recordId = ref('')

// 计算属性
const patientDiseaseId = computed(() => props.msg.patientDiseaseId || '')
const title = computed(() => props.msg.title || '')
const actionText = computed(() => props.msg.actionText || '查看处方')

const renderedTitle = computed(() => {
  const titleVal = title.value
  const actionTextVal = actionText.value
  const index = titleVal.indexOf(actionTextVal)
  if (index === -1 || !actionTextVal) {
    return [{ text: titleVal, isAction: false }]
  }
  const result = []
  if (index > 0) {
    result.push({ text: titleVal.slice(0, index), isAction: false })
  }
  result.push({ text: actionTextVal, isAction: true })
  if (index + actionTextVal.length < titleVal.length) {
    result.push({ text: titleVal.slice(index + actionTextVal.length), isAction: false })
  }
  return result
})

const serviceItems = computed(() => {
  const items = props.msg.serviceItems
  if (Array.isArray(items)) {
    return items
  }
  if (typeof items === 'string' && items) {
    try {
      return JSON.parse(items)
    } catch (e) {
      return []
    }
  }
  return []
})

const traceDescription = computed(() => props.msg.traceDescription || '')

// 方法
const onViewPrescription = () => {
  if (!patientDiseaseId.value) return
  visible.value = true
  recordId.value = patientDiseaseId.value
  // wx.navigateTo({
  //   url: `/pages/center/caseHistory/offline-record-detail?id=${patientDiseaseId.value}`
  // })
}
</script>

<style scoped lang="scss">
.prescription-upload-success {
  width: 100%;
  border-radius: 12px;
  font-size: 16px;
  color: #1a1a1a;
  overflow: hidden;
  padding: 10px 12px;

  &__body {
    .title {
      display: inline-block;
      .title-node {
        display: inline;
      }
      .title-action {
        display: inline;
        color: #1890ff;
        cursor: pointer;
      }
    }

    .service-list {
      .service-item {
        display: flex;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        .check-icon {
          margin-right: 6px;
          .icon-a-Shieldanquan {
            font-size: 16px;
          }
        }

        .service-text {
          flex: 1;
        }

        .safeIcon {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
}
</style>
